import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import SelectBoxIcon from '../../assets/icons/dropdown.svg';
import { Button } from '../Button';
import styles from './BackButton.css';
export const BackButton = memo(function BackButton({ label, onClick }) {
    return (_jsxs(Button, Object.assign({ onClick: onClick, className: styles.btnBack, title: `back to ${label}` }, { children: [_jsx(SelectBoxIcon, { className: styles.arrowLeft }, void 0), _jsxs("div", Object.assign({ className: styles.wrapper }, { children: ["back to", ' ', label] }), void 0)] }), void 0));
});
